import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ShortenedLinks from './components/ShortenedLinks';
import RedirectPage from './components/RedirectPage';
import HomePage from './components/HomePage';
import LoginPage from './components/LoginPage';
import SignUpPage from './components/SignUpPage';
import Dashboard from './components/noDashboard';
import New_Dashboard from './components/New_Dashboard';
import NewDashboard from './components/newDB';
import DocumentationPage from './components/DocumentationPage';
import AboutPage from './components/AboutPage';
import FeaturesPage from './components/FeaturesPage';
import SupportPage from './components/SupportPage';
import Navigation from './components/Navbar';
import { AuthProvider } from './AuthProvider';
import './css/home.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./index.css";
import { Analytics } from "@vercel/analytics/react";
import LinkDetails from './components/LinkDetails';
import NewsPage from './components/NewsPage';
function App() {
  return (
    <AuthProvider>
      <Router>
        <div>
          {/* Navigation dynamically accesses AuthContext */}
          <Navigation />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/new" element={<NewDashboard />} />
            <Route path="/shortened-links" element={<ShortenedLinks />} />
            <Route path="/:shortUrl" element={<RedirectPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/dashboard" element={<New_Dashboard />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="*" element={<HomePage />} />
            <Route path="/documentation" element={<DocumentationPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/:shortUrl/details" element={<LinkDetails />} />
            <Route path="/:shortUrl+" element={<LinkDetails />} /> 
            <Route path="/news" element={<NewsPage />} /> 
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
